import type { BadgeTone } from '../../components/Badge';

/**
 * El tono de la etiqueta de estado de una empresa.
 *
 * El estado llega del servidor como `active`/`paused`/`archived` y se pintaba
 * en crudo, en inglés y sin más. Aquí solo se decide el color: la palabra la
 * pone el catálogo, en `status.company.*`, porque el valor es un identificador
 * del contrato (`00-README §4.1`) y no se traduce en el modelo.
 */
export function companyStatusTone(status: string): BadgeTone {
  const tones: Record<string, BadgeTone> = { active: 'success', paused: 'warning', archived: 'neutral' };

  return tones[status] ?? 'neutral';
}
